<template lang="html">
    <vs-popup :active.sync="$props.popupActive" title="Message commercial">
        <vs-table
		stripe pagination max-items="25"
		:data="notes"
		:max-height= "tableHeight + 'px'"
		id="tb"
		noDataText="Aucune contract corresponde"
    >
    <template slot="thead">
        <vs-th class="th-sticky">Par</vs-th>
        <vs-th class="th-sticky pdl0">Note</vs-th>
        <vs-th class="th-sticky pdl0">Date</vs-th>
    </template>

    <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(note, index) in data">
			<!--For just calculating the number of rows-->
			<!--For just calculating the number of rows-->
            <vs-td >
                <!-- <vx-tooltip
                :text="note.name"
							position="top"
						></vx-tooltip> -->
							<vs-avatar style="border: 1px solid #08B0B9; margin-left: 0;" :text="note.name" :src="getCollaboratorAvatar(note.destination_user_id)"></vs-avatar></vs-td>
            <vs-td style="width: 80%;">
                {{ note.comment }}
			</vs-td>
            <vs-td >
                {{ new Date(note.created_date).toISOString().split("T")[0] }}
			</vs-td>
        </vs-tr>
    </template>
    </vs-table>
             <!-- </vx-card> -->
            </vs-popup>
         </template>

	<script>
	import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
	import VueCookies from "vue-cookies";
	import store from "@/store/store";
	export default {
	created(){
		this.consultantList = this.allCollaborators;
		this.getNotes();
		//getting orders which belongs to user sign in




	},
	updated(){
		// //console.log("dsadsads");
        // this.getNotes();
	},
	components: {

	},
	mounted(){

	},
	name: "AllNotesPopup",
	mixins: [dbFieldConvertor],
	props: {
		popupActive: Boolean,
		contract_id: Number,
		selectedCommercial: Number,
	},

	data() {
		return {
			// apiUrl: this.$store.state.backendApiUrl,
			newNote: "",
			notes: [],

		};
	},
	computed: {
        allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
		allCollaborators: () => {
			return store.state.collaborators;
		},
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		apiUrl: () => {
			return store.state.backendApiUrl;
		}
	},
	methods: {

		getNotes: function() {
			this.$http.get(this.apiUrl+"contract/getNotes/"+ this.$props.contract_id)
				.then(res => {
					this.notes = res.data;
				})
				.catch((err) => {
					this.$vs.notify({
						title: "Echec",
						text: ""
					});
				});
		},
        getCollaboratorAvatar(userId){
			try{
				let foundAvatar = this.allCollaboratorsAvatar.find(avatar => avatar.id == userId);
				if(foundAvatar) return foundAvatar.avatar;
				else return null;
			}
			catch(e){
				console.error(e);
			}

		},
		deleteNote: function(index) {
			this.notes.splice(index, 1);
		},
		onchangeNote(note){
			this.newNote= note;
		},
		/*
		 * changeConsultant(consultant){
		 * 	this.selectedCommercial = consultant;
		 * 	//console.log(consultant);
		 * }
		 */
	},
	watch: {

	}
};
</script>
